import { render } from "./adminAccount.vue?vue&type=template&id=43396aba"
import script from "./adminAccount.vue?vue&type=script&lang=js"
export * from "./adminAccount.vue?vue&type=script&lang=js"

import "./adminAccount.vue?vue&type=style&index=0&id=43396aba&lang=css"

import exportComponent from "D:\\childu_lms\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__